import runtime from '../utils/runtime';
import logger from '../logger/index';

function isBrowser() {
  return typeof window !== 'undefined';
}

export function checkCompat(env) {
  if (
    isBrowser() &&
    window.navigator.cookieEnabled &&
    window.MutationObserver &&
    window.performance &&
    window.performance.timing &&
    window.performance.navigation &&
    window.performance.getEntriesByType &&
    window.localStorage &&
    window.requestAnimationFrame
  ) {
    return true;
  } else if (isBrowser()) {
    const runtimeEnv = env || runtime.get('env')
  
    if (runtimeEnv !== 'prod') {
      logger.error('[performance-collect]: 设备不支持性能工具');
    }
  
    return false;
  }

  return false;
}

export function performanceNowAvailable() {
  return !!performance.now;
}
